import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-bankstatementuploadmodal',
  templateUrl: './bankstatementuploadmodal.component.html',
  styleUrls: ['./bankstatementuploadmodal.component.css']
})
export class BankstatementuploadmodalComponent implements OnInit {
  @Input('attachment_for_analysis') attachment_for_analysis:any;
  @Input('request_id') request_id:any;
  is_done = '0';
  loading = false;
  constructor() {
  }

  ngOnInit() {
  }
  confirmBankAccount(){

  }
}
